import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { getDocumentacionFile } from "../../services/normativas";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";


export const VisorPdfScreen = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const fileName = searchParams.get("fileName") || "documento.pdf";
  const key = searchParams.get("id");
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    const load = async () => {
      setError(null);
      setPdfUrl(null);
      if (!key || !id) {
        setLoading(false);
        setError("Faltan datos para cargar el documento.");
        return;
      }
      setLoading(true);
      try {
        const file = await getDocumentacionFile({ id: key, fileName: id });
        if (cancelled) {
          return;
        }
        if (file) {
          objectUrl = URL.createObjectURL(file);
          setPdfUrl(objectUrl);
        }
      } catch (e) {
        if (!cancelled) {
          setError(
            e instanceof Error ? e.message : "No se pudo cargar el documento.",
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void load();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [key, id]);

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
        getFilePlugin: {
            fileNameGenerator: () => fileName,
        }
    },
    renderToolbar: (Toolbar) => (
        <Toolbar>
            {(slots) => {
                return (
                    <div className="rpv-toolbar" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div style={{ padding: '0px 2px' }}><slots.ShowSearchPopover /></div>
                        <div style={{ padding: '0px 2px' }}><slots.GoToPreviousPage /></div>
                        <div style={{ padding: '0px 2px' }}><slots.CurrentPageInput /></div>
                        <div style={{ padding: '0px 2px' }}><slots.GoToNextPage /></div>
                        <div style={{ padding: '0px 2px' }}><slots.ZoomOut /></div>
                        <div style={{ padding: '0px 2px' }}><slots.Zoom /></div>
                        <div style={{ padding: '0px 2px' }}><slots.ZoomIn /></div>
                        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}><slots.EnterFullScreen /></div>
                        <div style={{ padding: '0px 2px' }}><slots.Download /></div>
                        <div style={{ padding: '0px 2px' }}><slots.Print /></div>
                    </div>
                );
            }}
        </Toolbar>
    ),
  });

  const centerMessage = (text: string, isError = false) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontFamily: "sans-serif",
        padding: 24,
        textAlign: "center",
        color: isError ? "#b42318" : undefined,
        maxWidth: 560,
        margin: "0 auto",
      }}
    >
      {text}
    </div>
  );

  return (
    // https://react-pdf-viewer.dev/docs/basic-usage/
    <>
    <style>{`
      @media print {
        /*
         * Cuando la librería activa la impresión, agrega su zona de páginas
         * directamente al body (fuera del #root de React).
         * Sin esto, el #root con height:100vh genera una hoja en blanco extra y en la impresion aparece un apgina extra en blanco.
         */
        .rpv-print__body-printing #root {
          display: none !important;
        }
      }
    `}</style>
    <div style={{ height: "100vh", width: "100vw", overflow: "hidden", margin: 0, padding: 0 }}>
      {error ? (
        centerMessage(error, true)
      ) : loading ? (
        centerMessage("Cargando documento...")
      ) : pdfUrl ? (
        // se descargó el js para no tenerlo como cdn por temas de seguridad, la version descargada es esta: https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js el 24/02/2026
        <Worker workerUrl={`${process.env.PUBLIC_URL}/react-pdf/pdf.worker.min.js`}>
          <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      ) : (
        centerMessage("No se pudo mostrar el documento.")
      )}
    </div>
    </>
  );
};
